<template>
  <div
    v-if="initdisplay"
    id="floorSelect"
  >
    <v-speed-dial
      v-model="fab"
      class="speed-dial"
      :direction="$mq | mq({
        mobile: 'top',
        tablet: 'left',
        desktop: 'top',
      })"
      scale
    >
      <template v-slot:activator>
        <v-btn
          v-model="fab"
          fab
          small
          height="3em"
          style="border-radius:10px; margin: 0.25em;width: 3em;"
        >
          <v-icon
            v-if="fab"
          >
            mdi-close
          </v-icon>
          <v-icon
            v-else-if="currentFloor === undefined"
          >
            mdi-layers-outline mdi-24px
          </v-icon>
          <v-icon
            v-else-if="currentFloor >= 0"
          >
            mdi-home-floor-{{ currentFloor }}
          </v-icon>
          <v-icon
            v-else-if="currentFloor === -1"
          >
            mdi-home-floor-negative-1
          </v-icon>
          <v-icon
            v-else
          >
            mdi-home
          </v-icon>
        </v-btn>
      </template>

      <v-btn
        class="floor"
        :class="{'floor-mobile': fab}"
        fab
        small
        :color="baseColorAccent"
        style="fontWeight:400;"
        elevation="10"
        @click="onUpdate(undefined)"
      >
        <v-icon :style="{color:iconColor}">
          mdi-border-none-variant
        </v-icon>
      </v-btn>
      <v-btn
        v-for="layer in floorList"
        :key="layer.meta.floor"
        class="floor"
        :class="{'floor-mobile': fab}"
        fab
        small
        :color="baseColorAccent"
        style="fontWeight:400;"
        elevation="10"
        @click="onUpdate(layer)"
      >
        <div :style="{color:iconColor}">
          {{ layer.meta.floor }}
        </div>
      </v-btn>
    </v-speed-dial>
  </div>
</template>

<script>

import { EventBus } from '../../event-bus';
import { Mapable } from '../../mixins/Mapable';

export default {
  name: 'FloorSelect',
  mixins: [Mapable],
  data() {
    return {
      floorList: [],
      initdisplay: this.$appConfig.floorSelector,
      baseColor: this.$appConfig.baseColor,
      baseColorAccent: this.$appConfig.baseColorAccent,
      iconColor: this.$appConfig.iconColor,
      fab: false,
      currentFloor: undefined,
    };
  },
  computed: {
    bookmarks() {
      return this.$store.bookmarks;
    },
  },
  mounted() {
    const me = this;
    EventBus.$on('showingBookmarks', () => {
      this.fab = false;
    });
    EventBus.$on('layer-meta', (layer) => {
      let temp = this.floorList;
      if (layer.meta.type === 'floor') {
        temp.push(layer);
      }
      temp = Array.from(new Set(temp));
      me.floorList = temp;
    });
  },
  methods: {
    onMapBound() {
    },
    onUpdate(layer) {
      const me = this;
      if (layer === undefined) {
        this.currentFloor = undefined;
        me.floorList.forEach((floorLayer) => {
          floorLayer.layers.forEach((l) => {
            me.map.setLayoutProperty(l.id, 'visibility', 'none');
          });
        });
        return;
      }
      me.floorList.forEach((floorLayer) => {
        if (layer === floorLayer) {
          this.currentFloor = layer.meta.floor;
          floorLayer.layers.forEach((l) => {
            me.map.setLayoutProperty(l.id, 'visibility', 'visible');
          });
        } else {
          floorLayer.layers.forEach((l) => {
            me.map.setLayoutProperty(l.id, 'visibility', 'none');
          });
        }
      });
    },
  },
};

</script>

<style scoped>
.activeFloor {
  color: red !important;
}
@media (max-width: 450px) {
  .floor-mobile {
    top: 40vh;
    right: calc(50vw - 1.5em);
    -webkit-transform: translateX(50%);
    transform: translateX(50%);
  }
}
</style>
